const app_name = 'AutoExpertos Operaciones'
const app_logo = 'https://cdn.prod.website-files.com/618c320466a1e45517562327/65f2fc787f3ce288ac5bf1e2_Logos-AutoExpertos-1.svg'
const app_menu_background = '#0B1F38'
const app_version = "©AutoExpertos V.2024.08.13"
const metabase_site_url = 'https://autoexpertos.metabaseapp.com'
const metabase_key = '03ae844b5e5b8db2b740ceb82826ab0a77752614424e91760a23413645afef4c'
export default { app_name, app_logo, app_menu_background, app_version, metabase_site_url, metabase_key }